module.exports = "<div users-wrapper page-class=\"users-login\">\n  <div md-whiteframe=\"1\" class=\"content-box text-center\">\n    <h1>{{ \"COMMONS.PLEASE_WAIT\" | translate }}</h1> \n  </div>\n</div>\n  \n  ";


//////////////////
// WEBPACK FOOTER
// ./src/users/client/client-activation.html
// module id = 235
// module chunks = 0